if (!customElements.get('amare-cart-upsell')) {
  customElements.define('amare-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-upsell-product-tab]').forEach((button) => {
        button.addEventListener('click', () => this.selectProduct(button));
      });
      this.querySelectorAll('[data-upsell-variant]').forEach((button) => {
        button.addEventListener('click', () => this.selectVariant(button));
      });
    }

    selectProduct(button) {
      const productId = button.dataset.upsellProductTab;

      this.querySelectorAll('[data-upsell-product-tab]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-upsell-product-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.upsellProductPanel !== productId;
      });
    }

    selectVariant(button) {
      const panel = button.closest('[data-upsell-product-panel]');
      if (!panel) return;

      const available = button.dataset.variantAvailable === 'true';
      const input = panel.querySelector('product-form [name="id"]');
      const submit = panel.querySelector('product-form [type="submit"]');
      const color = panel.querySelector('[data-upsell-color]');
      const price = panel.querySelector('[data-upsell-price]');
      const image = panel.querySelector('[data-upsell-link] img');
      const link = panel.querySelector('[data-upsell-link]');

      panel.querySelectorAll('[data-upsell-variant]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (input) {
        input.value = button.dataset.variantId;
        input.disabled = !available;
      }
      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', available ? 'false' : 'true');
        const label = submit.querySelector('[data-upsell-submit]');
        if (label) label.textContent = available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      }
      if (color) color.textContent = (this.dataset.labelSelectedColor || '__COLOR__').replace('__COLOR__', button.dataset.variantTitle);
      if (price) price.textContent = button.dataset.variantPrice;
      if (link) link.href = button.dataset.variantUrl;
      if (image && button.dataset.variantImage) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = button.dataset.variantImage;
      }
    }
  });
}
